import React from 'react'
import { Form, Grid, Message } from 'semantic-ui-react'
import { connect } from 'react-redux';
import { login, loginRest, setTokenAction } from './LoginActions';
import translate from 'react-i18next/dist/commonjs/translate';
import { Captcha } from "reactjs-captcha"; 
import { captchaSettings } from "reactjs-captcha";


class LoginFormComponent extends React.Component {

  constructor(props) {
    super(props)
    captchaSettings.set({ 
      captchaEndpoint: 
        '/ndapmoci/simple-captcha-endpoint' 
    });      
    this.state = {
      username: "",
      password: "",
      userEnteredCaptchaCode: "",
      captchaId: "",
      showMessage: false
    }
   
  }

  componentDidMount() {
    this.props.dispatch(setTokenAction(this.props.md5Hash));
  }

  onInputChange = (event, data) => {
    this.setState({ ...this.state, [event.target.name]: data.value.trim(), showMessage: false })
  }

  login = () => {

    let userEnteredCaptchaCode = this.captcha.getUserEnteredCaptchaCode(); 

    let captchaId = this.captcha.getCaptchaId();

    if(this.props.loginRest) {
      this.props.dispatch(loginRest(this.state.username, this.state.password, userEnteredCaptchaCode, captchaId));
    } else {
      this.props.dispatch(login(this.state.username, this.state.password, this.state.code, this.state.coduserEnteredCaptchaCode, this.state.captchaId));      
    }
    this.setState({ ...this.state, showMessage: true })
  }

  render() {
    const { t } = this.props
    return (
      <div className='login-form'>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Form size='large' onSubmit={this.login}>
              <Form.Input
                name="username"
                onChange={this.onInputChange}
                fluid
                icon='user'
                iconPosition='left'
                placeholder={t('username')}
              />
              <Form.Input
                name="password"
                onChange={this.onInputChange}
                fluid
                icon='lock'
                iconPosition='left'
                placeholder={t('password')}
                type='password'
                className="password-field"
              />
              {this.props.loginRest &&
                <div className="forgot-password-block">
                  <span className="label-as-link" onClick={this.props.onForgotPasswordClick}>{t("forgotPasswordLink")}</span>
                </div>
              }
              <Form.Input
                name="code"
                id="yourFirstCaptchaUserInput"
                onChange={this.onInputChange}
                fluid
                icon='qrcode'
                iconPosition='left'
                placeholder={t('captchaCode')}
              />
              <Captcha captchaStyleName="yourFirstCaptchaStyle" 
                    ref={(captcha) => {this.captcha = captcha}}  />
              <Form.Button compact fluid size='large'>
                {t('loginRegister')}
              </Form.Button>
            </Form>
            {(!this.props.isLoggedIn && this.props.error !== null && this.state.showMessage) && !this.captcha.reloadImage() &&
              <Message error>
                {t(this.props.error)}
              </Message>
            }
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.loginReducer.isLoggedIn,
    error: state.loginReducer.error
  }
}

const LoginFormContainer = connect(mapStateToProps)(LoginFormComponent)

export default translate()(LoginFormContainer);


// WEBPACK FOOTER //
// ./src/features/common/login/login-form/LoginFormContainer.jsx